import React from 'react';
import { Newsletter } from '../../types/types';

interface Props {
  newsletter: Newsletter;
  formerProUser: boolean;
}

const ProNewsletterViewOnly: React.FC<Props> = ({ newsletter, formerProUser }: Props) => {
  const REGISTER_PRO_PATH = '/register/PRO';
  const linkText = formerProUser ? 'Sign up for PRO' : 'Try PRO for free';

  return (
    <div
      data-testid='newsletter-block'
      className={`newsletter-block col-lg-5 col-12 ${newsletter.accent_color} border-bottom`}
    >
      <div className='pb-md-2 pb-3 pt-3'>
        <div className='row'>
          <div className='col-sm-7 col-12'>
            <div className='frequency mb-1'>{newsletter.frequency}</div>
            <div className='mb-2'>
              <h2 className='title fs-3 fw-bold mb-0'>
                <i
                  data-testid='newsletter-icon'
                  className={`icon fal icon-${newsletter.icon} me-2`}
                ></i>{' '}
                {newsletter.name}
              </h2>
            </div>
          </div>
          <div className='d-none d-md-inline col-5 text-end pt-35'>
            <a href={REGISTER_PRO_PATH} className='btn btn-dark text-white'>
              {linkText}
            </a>
          </div>
          <div className='col-10 col-lg-11 ml-auto'>
            <span className='mt-2 mb-3 badge for-pro-badge'>For Pro members only</span>
            <div className='mb-3'>{newsletter.description}</div>
          </div>
          <div className='d-md-none'>
            <div className='col-12 text-center'>
              <a href={REGISTER_PRO_PATH} className='mobile-try-pro-link btn btn-dark text-white'>
                {linkText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProNewsletterViewOnly;
